var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.LuckyDraw.Messages.Draw, Vendd.LuckyDraw, function (envelope) {
        var options = {
            url: 'api/LuckyDraw/Draw',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.LuckyDraw, new Vendd.LuckyDraw.Messages.DrawSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.LuckyDraw, new Vendd.LuckyDraw.Messages.DrawFailure(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.LuckyDraw.Messages.GetSegmentsAndCurrentBalance, Vendd.LuckyDraw, function (envelope) {
        var options = {
            url: 'api/LuckyDraw/GetSegmentsAndCurrentBalance',
            method: 'GET',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.LuckyDraw, new Vendd.LuckyDraw.Messages.GetSegmentsAndCurrentBalanceSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.LuckyDraw, new Vendd.LuckyDraw.Messages.GetSegmentsAndCurrentBalanceFailure(response));
        }

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});